import React, { Component } from 'react'
import { LocaleProvider, Layout } from 'antd'
import { map } from 'lodash'

import { Route, Switch, withRouter, Redirect } from 'react-router-dom'

import enUS from 'antd/lib/locale-provider/en_US'

import MainMenu from '~/components/menu'
import ShopSelector from '~/components/shop-selector'
import Search from '~/components/search'
import LanguageSelector from "~/components/language";

import logic from '~/scenes/logic'

import bundles, { routes } from './bundles'

const { Sider, Content } = Layout;

@withRouter
@logic
class App extends Component {
  showSidebar = () => {
    const { loggedIn, contentVisible, children, location } = this.props;

    return loggedIn && location.pathname.indexOf('/validate/') === -1 ;
  }
  render () {
    const { loggedIn, contentVisible, children } = this.props;
    const routeItems = map(routes, (sceneId, route) => {
      return <Route key={route} path={ route } exact={ true } component={ bundles[sceneId] }/>
    })

    return (
      <LocaleProvider locale={enUS}>
        <div className="main-wrapper">
          <Layout>
            { this.showSidebar() ?
              <Sider width={ 240 }>
                <div className="branding">
                  Gratify
                </div>
                <ShopSelector />
                <MainMenu />
              </Sider>
            : null }
            <Content>
              <div className="main-content">
                <Switch>
                  <Route key={'/login/'} path={ '/login/' } exact={ true } component={ bundles.login }/>
                  <Redirect from='/products/:productId/edit/' exact={ true } to='/products/:productId/edit/overview/'/>
                  { routeItems }
                </Switch>
                { contentVisible ?
                  <div>
                    <Search />
                  </div>
                : null }
              </div>
            </Content>
          </Layout>
        </div>
      </LocaleProvider>
    )
  }
}

export default App
